import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messageInput", "form"]

  connect() {
    this.scrollToBottom()
  }

  handleKeydown(event) {
    // Submit on Enter (without Shift)
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.submitForm()
    }
  }

  submitForm() {
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }

  attachmentChanged(event) {
    const file = event.target.files[0]
    if (file) {
      // You could show a preview here
      console.log("Attachment selected:", file.name)
    }
  }

  scrollToBottom() {
    const container = document.getElementById("messages-container")
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }
}
